import React, { useEffect, useState } from 'react';
import { ContentParagraph } from '../../../../../../_lib/components/ContentParagraph';
import { ContentLink } from '../../../../../../_lib/components/ContentLink';
import { useSonTranslation } from '../../../../../../translation/useSonTranslation';
import ILink from '../../../../../../types/ILink';
import { RefetchBlock } from '../../../../RefetchBlock';
import { LoadingSpinnerContainer } from '../../../../../atoms/LoadingSpinner';
import { useFetch } from '../../../../../../hooks/useFetch';
import { sendLiveRegionMessage } from '../../../../../atoms/LiveRegionGlobal/LiveRegionGlobal';
import { LinkingPageType } from '../../../../../../types/api/LinkingPageType';

type LinkingPagesType = {
  linkingPages: LinkingPageType;
};
export function LinkingPages({ linkingPages }: LinkingPagesType) {
  const { t } = useSonTranslation('FormSubmitOrCancel');
  const [pages, setPages] = useState<ILink[]>([]);
  const { get, requestError, isLoading } = useFetch();

  const fetchLinkingPages = async (fetchUrl: string) => {
    sendLiveRegionMessage(t('linkingPagesIsLoading'));
    const res = await get(fetchUrl);
    if (res?.data) {
      if (res.data.links.length === 0) {
        sendLiveRegionMessage(t('noLinkingPages'));
      }
      setPages(res.data.links);
    }
  };

  useEffect(() => {
    fetchLinkingPages(linkingPages.fetchUrl);
  }, []);

  if (pages?.length === 0 && !isLoading && !requestError) {
    return null;
  }

  return (
    <>
      {isLoading && <LoadingSpinnerContainer />}
      {requestError && !isLoading && <RefetchBlock refetchBlock={() => fetchLinkingPages(linkingPages.fetchUrl)} />}
      {pages?.length > 0 && (
        <>
          <div className="form-submit-or-cancel__linking-pages-text">
            <ContentParagraph>{t('hintOfLinkingPages')}</ContentParagraph>
          </div>
          <div className="form-submit-or-cancel__linking-pages-scroll-container">
            <ul>
              {pages.map(page => (
                <li key={page.name} className="form-submit-or-cancel__linking-pages-list-element">
                  <ContentLink key={page.name} to={page.url}>
                    {page.name}
                  </ContentLink>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
}
